<template>
	<div class="kyc w100">
		<div class="select_area mb_10">
			<select
				class="contact_type"
				v-model="typeSeq"
				@change="loadKycCertificationForm"
			>
				<option
					v-for="item in certificationTypes"
					:key="item.seq"
					:value="item.seq"
				>
					{{ item.title }}
				</option>
			</select>
			<span class="select_icon"></span>
		</div>
		<div v-if="!kycCertification">
			<div v-for="form in kycForm" :key="form.seq" class="kyc_input_area">
				<h3 class="form_title">{{ form.title }}</h3>
				<p class="mb_10">{{ form.description }}</p>
				<div
					v-for="(field, idx) in form.fields"
					:key="field.seq"
					class="field_area"
				>
					<!-- <h4 class="field_title">{{ field.title }}</h4>
					<p class="mb_10">{{ field.description }}</p> -->
					<template v-if="field.field_type === 'INPUT'">
						<input
							type="text"
							v-model="form.fieldValues[idx].value"
							class=""
							:placeholder="field.placeholder"
						/>
					</template>
					<template v-if="field.field_type === 'TEXTAREA'">
						<textarea rows="5" v-model="form.fieldValues[idx].value"></textarea>
					</template>
					<template v-if="field.field_type === 'RADIO'">
						<div class="d_flex mb_10">
							<div v-for="item in field.options" :key="item.seq" class="mr_20">
								<input
									type="radio"
									:name="'radio_' + form.seq + '_' + idx"
									v-model="form.fieldValues[idx].optionSeq"
									:value="item.seq"
								/>
								<label>{{ item.title }}</label>
							</div>
						</div>
					</template>
					<template v-if="field.field_type === 'SELECT'">
						<div class="select_area">
							<select v-model="form.fieldValues[idx].optionSeq">
								<option
									v-for="item in field.options"
									:key="item.seq"
									:value="item.seq"
								>
									{{ item.title }}
								</option>
							</select>
							<span class="select_icon"></span>
						</div>
					</template>
					<template v-if="field.field_type === 'CHECKBOX'">
						<div v-for="item in field.options" :key="item.seq">
							<input
								type="checkbox"
								:name="'checkbox' + form.seq + '_' + idx"
								v-model="form.fieldValues[idx].options"
								:value="item.seq"
							/>
							<label for="">{{ item.title }}</label>
						</div>
					</template>
					<template v-if="field.field_type === 'MULTISELECT'">
						<p>멀티셀렉</p>
						<div class="select_area">
							<select v-model="form.fieldValues[idx].options" multiple size="1">
								<option
									v-for="item in field.options"
									:key="item.seq"
									:value="item.seq"
								>
									{{ item.title }}
								</option>
							</select>
							<span class="select_icon"></span>
						</div>
					</template>
					<template v-if="field.field_type === 'FILE'">
						<h3 class="form_title">Document</h3>
						<div class="file_upload_area">
							<div
								class="file_drop_zone"
								:class="{ 'drag-over': dragOver }"
								@drop="handleFileDrop($event, form.seq, idx)"
								@dragover.prevent="dragOver = true"
								@dragleave="dragOver = false"
								@dragenter.prevent
								@click="$refs[`fileInput_${form.seq}_${idx}`][0].click()"
							>
								<div v-if="!form.fieldValues[idx].file" class="drop_message">
									<div class="upload_icon">
										<img
											:src="iconUpload"
											alt=""
											style="width: 30px; height: 30px"
										/>
									</div>
									<p>Drag or click to add files</p>
								</div>
							</div>
							<input
								type="file"
								:ref="`fileInput_${form.seq}_${idx}`"
								@change="handleFileSelect($event, form.seq, idx)"
								accept="image/*,.pdf"
								style="display: none"
							/>
						</div>
					</template>
				</div>
			</div>
			<div v-if="kycForm.length > 0" class="kyc_button_area tac">
				<button class="button_bg_blue" @click="createCertification">
					Submit
				</button>
			</div>
		</div>
		<div
			class="text_status"
			v-else
			:class="{
				'status-complete': kycCertification.status === 'APPROVED',
				'status-under-review': kycCertification.status === 'PENDING',
				'status-rejected': kycCertification.status === 'REJECTED',
			}"
		>
			<img
				v-if="kycCertification.status === 'APPROVED'"
				:src="iconComplete"
				alt="Complete"
				class="status-icon"
			/>
			<img
				v-if="kycCertification.status === 'PENDING'"
				:src="iconUnderReview"
				alt="Under Review"
				class="status-icon"
			/>
			{{
				kycCertification.status === 'REJECTED'
					? 'Rejected'
					: kycCertification.status === 'PENDING'
					? 'Under Review'
					: 'Complete'
			}}
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div class="status_icon success"></div>
		<p class="status_text">Request Submitted</p>
		<div class="button_area">
			<button class="button_bg_blue" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import {
	createCertification,
	fetchCertificationList,
	fetchCertificationTypes,
} from '@/api/kyc';
import { commonError } from '@/common/dialog';
import { fetchKycCertificationTypeForm } from '@/api/form';
import ModalMessage from '@/components/Layout/ModalMessage';
import iconUpload from '@/assets/images/v2/icon/icon-upload.svg';
import iconComplete from '@/assets/images/v2/icon/icon-complete.svg';
import iconUnderReview from '@/assets/images/v2/icon/icon-under-review.svg';
export default {
	name: 'Kyc',
	components: { ModalMessage },
	data() {
		return {
			kycCertificationList: [],
			typeSeq: '',
			certificationTypes: [],
			kycForm: [],
			messageModal: false,
			dragOver: false,
			iconUpload,
			iconComplete,
			iconUnderReview,
		};
	},
	computed: {
		kycCertification() {
			return this.kycCertificationList.find(item => {
				return (
					item.type_seq === this.typeSeq &&
					~['PENDING', 'APPROVED'].indexOf(item.status)
				);
			});
		},
	},
	created() {
		Promise.all([this.loadKycCertificationType(), this.loadKycCertification()])
			.then(() => this.loadKycCertificationForm())
			.catch(commonError);
	},
	methods: {
		async loadKycCertification() {
			const { data } = await fetchCertificationList({}).catch(commonError);
			this.kycCertificationList = data;
		},
		async loadKycCertificationType() {
			const { data } = await fetchCertificationTypes().catch(commonError);
			this.certificationTypes = data;
			if (data.length) {
				this.typeSeq = data[0].seq;
			}
		},
		async loadKycCertificationForm() {
			if (!this.typeSeq) return;

			const params = {
				type_seq: this.typeSeq,
				target_type: 'KYC_CERTIFICATION',
			};
			const { forms } = await fetchKycCertificationTypeForm(params).catch(
				commonError,
			);
			this.kycForm = forms.map(form => {
				let result;
				const fieldValues = form.fields.map(field => {
					return {
						fieldSeq: field.seq,
						value: '',
						optionSeq: null,
						options: [],
					};
				});
				result = { ...form, fieldValues: fieldValues };
				return result;
			});
		},
		async createCertification() {
			const fieldValues = [];
			this.kycForm.forEach(form => {
				form.fieldValues.forEach(field => {
					fieldValues.push({
						field_seq: field.fieldSeq,
						option_seq: field.optionSeq,
						value: field.value,
						options: field.options.map(option => {
							return { option_seq: option };
						}),
					});
				});
			});
			const data = {
				type_seq: this.typeSeq,
				field_values: fieldValues,
			};

			createCertification(data)
				.then(() => {
					this.messageModal = true;
				})
				.then(() => this.loadKycCertification())
				.catch(commonError);
		},

		handleFileSelect(event, formSeq, fieldIdx) {
			const file = event.target.files[0];
			if (file) {
				this.validateAndSetFile(file, formSeq, fieldIdx);
			}
		},

		handleFileDrop(event, formSeq, fieldIdx) {
			event.preventDefault();
			this.dragOver = false;

			const files = event.dataTransfer.files;
			if (files.length > 0) {
				this.validateAndSetFile(files[0], formSeq, fieldIdx);
			}
		},

		validateAndSetFile(file, formSeq, fieldIdx) {
			// 파일 크기 검증 (10MB)
			const maxSize = 10 * 1024 * 1024;
			if (file.size > maxSize) {
				alert('파일 크기는 10MB 이하여야 합니다.');
				return;
			}

			// 파일 형식 검증
			const allowedTypes = [
				'image/jpeg',
				'image/jpg',
				'image/png',
				'application/pdf',
			];
			if (!allowedTypes.includes(file.type)) {
				alert('JPG, PNG, PDF 파일만 업로드 가능합니다.');
				return;
			}

			// 파일 설정
			const form = this.kycForm.find(f => f.seq === formSeq);
			if (form) {
				this.$set(form.fieldValues[fieldIdx], 'file', file);
			}
		},
	},
};
</script>
